<template>
 <div class="map-container">
  <div style="width: 100%; height: 100%">
    <GmapMap ref="mapRef"
      :center="center"
      :zoom="5"
      map-type-id="terrain"
      style="width: 100%; height: 100%">
      <GmapCluster :zoomOnClick="true">
        <GmapMarker
          :key="`marker${index}`"
          v-for="(m, index) in markers"
          :position="m.position"
          :icon="m.icon"
          :clickable="true"
          @click="toggleInfoWindow(m,index)"/>
      </GmapCluster>
      <GmapInfoWindow :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false">
        <span v-html="infoContent"></span>
      </GmapInfoWindow>
    </GmapMap>
  </div>
  </div>
</template>
<script>
import TruckSmallIcon from '@common/asset/images/truck-small.svg';
import { getDateDiffInDaysMins, formatDetailedTime, formatLastKnownTime } from '@/lib/Date';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  props: {
  },
  data() {
    return {
      TruckSmallIcon,
      trips: [],
      markers: [],
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -25,
        },
      },
      infoWindowPos: null,
      infoWinOpen: false,
      infoContent: '',
      currentMidx: null,
      center: {},
    };
  },
  computed:{
    ...mapGetters({
      currentClient: 'app/currentClient'
    }),
  },
  created() {
    const data = this.$session.get('activeTripDetails');
    if (data) {
      const latestLocation = data;
      this.trips = latestLocation.map(location => ({
        lat: location.latest_location.lat,
        lng: location.latest_location.lon,
        position: {
          lat: location.latest_location.lat,
          lng: location.latest_location.lon,
        },
        locationDetails: {
          haltTime: location.latest_location.haltTime,
        },
        icon: `${this.TruckSmallIcon}`,
        created_at: new Date(location.latest_location.createdAt),
        details: {
          shipment_number: location.shipment_number,
          eta: location.eta,
          transporter_name: location.transporter_name,
          driver_number: location.driver_number,
          last_known_city: location.latest_location.city || location.latest_location.address,
          last_known_time: location.latest_location.createdAt,
        },
      }));
      this.markers = this.trips;
    }
  },
  watch: {
    currentClient(value) {
      if (value && value.latitude && value.longitude) {
        this.center = {
          lat: value.latitude,
          lng: value.longitude,
        };
      } else {
        this.center = { lat: 20.5937, lng: 78.9629 };//india's lat long
      }
    },
  },
  methods: {
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '';
      if (marker.details) {
        const etaDiff = (marker.details.eta === 'NA') ? '' : getDateDiffInDaysMins(marker.details.eta, moment());
        const eta = etaDiff ? etaDiff.formatted : '-';
        this.infoContent = `
          <div class="tooltip-map">
            <div>
              <label>Shipment ID</label>
              <div class="info-right">
                <span>${marker.details.shipment_number}</span>
              </div>
            </div>
            <div>
              <label>Current ETA</label>
              <div class="info-right">
                <span>${formatDetailedTime(marker.details.eta)}</span>
                <small class="timing">${eta}</small>
              </div>
            </div>
            <div>
              <label>Transporter</label>
              <div class="info-right">
                <span>${marker.details.transporter_name}</span>
              </div>
            </div>
            <div>
              <label>Driver No</label>
              <div class="info-right">
                <span>${marker.details.driver_number}</span>
              </div>
            </div>
            <div>
              <label>Last Known Location</label>
              <div class="info-right">
                <span>${marker.details.last_known_city}</span>
                <small>${formatLastKnownTime(marker.details.last_known_time)}</small>
              </div>
            </div>
          <div>`;
      }
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      this.center = marker.position;
    },
  },
};
</script>
<style lang="scss">
.map-container {
  height: 655px;
  position: relative;
}
.gm-style {
  img {
    margin: 0 !important;
  }
  .gm-style-iw-c {
    background-color: rgba(0,0,0,0.7);
    padding: 15px 10px 10px !important;
    border-radius: 2px;
    box-shadow: none;
  }
  .gm-style-iw-d {
    overflow: hidden !important;
  }
  .gm-style-iw-t::after {
    background: none;
    margin-left: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid rgba(0,0,0,0.7);
    box-shadow: none;
    transform: none;
  }
  .gm-ui-hover-effect {
    width: 15px !important;
    height: 15px !important;
    top: 4px !important;
    right: 7px !important;
  }
}
</style>
